// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Nx3Q","rootSuccess":"CompleteLink_rootSuccess__1gu6r","rootFailure":"CompleteLink_rootFailure__1MLmy","isDisabled":"CompleteLink_isDisabled__2aQ3t"};